{
  "auth.login.otp.email.back.button_label": "Atrás",
  "auth.login.otp.email.cancel.button_label": "Cancelar",
  "auth.login.otp.email.continue.button_label": "Continuar",
  "auth.login.otp.email.error_format": "Ingresa un correo electrónico válido",
  "auth.login.otp.email.forgot_password.link_text": "¿Olvidaste tu contraseña? Inicia sesión con código",
  "auth.login.otp.email.form.label": "Correo electrónico",
  "auth.login.otp.email.form.placeholder": "Correo electrónico",
  "auth.login.otp.email.passcode.form.helper_text": "Ingresa el código enviado a",
  "auth.login.otp.email.passcode.form.label": "Código",
  "auth.login.otp.email.passcode.form.placeholder": "Código",
  "auth.login.otp.email.passcode.helper_text": "Te enviaremos un código por correo electrónico para confirmar tu correo.",
  "auth.login.otp.email.passcode.resend.link_text": "¿No recibiste el correo? Reenviar código",
  "auth.login.otp.email.passcode.resend.link_text.resending": "Reenviando...",
  "auth.login.otp.email.passcode.switch_method.link_text": "Enviar código al número de teléfono",
  "auth.login.otp.email.password.label": "Contraseña",
  "auth.login.otp.email.password.placeholder": "Contraseña",
  "auth.login.otp.email.password.required": "Se requiere contraseña"
}
